import type { Option } from '@usealloy/component-library';
import type { PublishedAttribute } from 'flow/store/engine/types';

/**
 * Fields that are displayed in the Published Attribute form UI.
 * Includes fields relevant to PAs, to inputs/outputs and to action options
 */
export const publishedAttributeFormFields = [
  'attributeName',
  'attributeToken',
  'outputCategory',
  'containsPii',
  'defaultValue',
  'defaultValueNote',
  'hasExpiration',
  'hasJqFilter',
  'validValueMin',
  'validValueMax',
  'validValues',
  'jqFilter',
  'agentCanCreateValue',
  'groupingToken',
  'defineValueRanges',
  'outputValueRange',
  'outputValueRangeOptions',
] as const;

export type PublishedAttributeFormFields = (
    typeof publishedAttributeFormFields[number]
);

/**
 * Fields that can actually be updated on the backend for PAs.
 * Excludes read-only fields like dataType, containsPii, attributeToken, etc.
 * Excludes FE-only fields and action options fields (category, outputValueRange)
 * Used for typing reducer payloads and backend mutations.
 */
export const updatablePublishedAttributeFields = [
  'attributeName',
  'defaultValue',
  'defaultValueNote',
  'hasExpiration',
  'valueExpiresInDays',
  'hasJqFilter',
  'validValueMin',
  'validValueMax',
  'validValues',
  'jqFilter',
  'agentCanCreateValue',
  'groupingToken',
] as const;

export type UpdatablePublishedAttributeFields = (
  typeof updatablePublishedAttributeFields[number]
);

export type DataType = PublishedAttribute['dataType'];

export interface DataTypeOption extends Option {
  value: DataType;
}

/**
 * Shared FormState for both Input and Output Attribute Configuration.
 * Includes all fields that appear in the form, even if some are read-only.
 */
export type AttributeConfigurationFormState =
  Pick<PublishedAttribute, PublishedAttributeFormFields> & {
    dataType: DataTypeOption;
    valueExpiresInDays: number;
  };

